// extracted by mini-css-extract-plugin
export default {"fullWidth":"ip-z","image":"jp-z","lazyLoadPicture":"kp-z","lazyLoadSpinner":"lp-z","lazyLoadSpin":"mp-z","lazyLoadImage":"np-z","hasStyledAspectRatio":"op-z"};